import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './VirtualTourSuite.css';

class VirtualTourSuite extends Component {
    constructor(props) {
        super(props);
        this.filterChanged = this.filterChanged.bind(this);

        const { tours = '', virtual_tour_title } = this.props.property;

        let reorderTour = '';

        if (tours) {
            let filtered = [];

            tours.forEach(function (item) {
                filtered.push({
                    ...item.tour,
                    value: item.tour.tour_link,
                    label: item.tour.tour_name,
                });
            });
            reorderTour = filtered.sort((a, b) => a.tour_name.toLowerCase().localeCompare(b.tour_name.toLowerCase()));
        }


        this.state = {
            virtual_tour_title,
            tours: reorderTour,
            selectedOption: {
                label: 'SELECT A SUITE',
                value: reorderTour[0] ? reorderTour[0].tour_link : '',
                tour_link: reorderTour[0] ? reorderTour[0].tour_link : '',
            },
        };
    }

    filterChanged(data) {
        if (data.value !== '') {
            this.setState(() => ({
                selectedOption: data,
            }));
        }
    }

    render() {
        return (
            this.state.tours.length > 0 ? <div className="virtual-tour-suite">
                <div className="section">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-offset-1 is-6-tablet is-7-desktop is-7-widescreen">
                                <h3 className="big-title border-left-yellow">
                                    {this.state.virtual_tour_title}
                                </h3>
                            </div>
                            {this.state.tours.length > 1 && <div className="column">
                                <Select
                                    instanceId="virtual-tour-select"
                                    className="select-wrapper"
                                    classNamePrefix="react-select"
                                    placeholder={this.state.selectedOption.label}
                                    name="filter-by-suite"
                                    options={this.state.tours}
                                    isSearchable={false}
                                    value={this.state.selectedOption}
                                    onChange={this.filterChanged}
                                />
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="section vr-tour-suite-section">
                    <div className="container">
                        <div className="vr-iframe-wrapper">
                            <div className="placeholder-content">
                                <div className="loader"></div>
                                <iframe title="vr-iframe-tours" src={this.state.selectedOption.tour_link} frameBorder='0' allowFullScreen allow='xr-spatial-tracking'></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div> : null
        );
    }
}

VirtualTourSuite.propTypes = {
    property: PropTypes.object.isRequired,
};

export default VirtualTourSuite;
